import request from '../axiosInterceptor'
import { showError } from '../../utils/helper'
const api = {
  getStatisticsCapturesDashboard(query: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-flow/statistics-capture-dashboard/get-statistic-capture-report-list-dashboard${query}`,
      // url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/get-statistic-capture-report-list-dashboard?from_date${''}&to_date=${''}`,
      method: 'get',
    })
  },
  getStatisticsCapturesDashboardSchedules() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/dashboard/nai-flow/statistic-capture-schedule-list-dashboard`,
      method: 'get',
    })
  },
  getStatisticsCaptures(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/statistic-capture-schedule-list`,
      method: 'get',
    })
  },
  getStatisticsCapturesSchedulesIds(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/sc-schedule-id-list`,
      method: 'get',
    })
  },
  getStatisticsCaptureReport(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/statistic-capture-report-list`,
      method: 'get',
    })
  },
  getExportReport(id: any, format: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/statistic-capture-report-export?file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  getExportStatisticCaptureSchedule(id: any, format: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/statistic-capture-schedule-list-export?file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  getExportObservations(id: any, format: string, fromDate?: string, toDate?: string) {
    const params = new URLSearchParams({ file_format: format })
    if (fromDate) params.set('from_date', fromDate)
    if (toDate) params.set('to_date', toDate)
    const asBlob = format !== 'csv'
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/observations/observations-list-export?${params.toString()}`,
      method: 'get',
      responseType: asBlob ? 'blob' : undefined,
    })
  },
  getExportObservationsView(id: any, format: string,subsidiaryId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/linked-projects/observations/observations-list-export?project_details_id=${id}&subsidiary_master_id=${subsidiaryId}&file_format=${format}`,
      method: 'get',
      responseType: format === 'xlsx' ? 'blob' : undefined,
    })
  },
  postAddSchedule(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/add-statistic-capture`,
      method: 'post',
      data: data,
    })
  },
  getScheduleDetails(id: any, scheduleId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/statistic-capture-schedule?schedule_id=${scheduleId}`,
      method: 'get',
    })
  },
  postEditSchedule(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/edit-statistic-capture-schedule-details`,
      method: 'post',
      data: data,
    })
  },
  getStatisticsCaptureReportDetails(id: any, taskId: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/get-statistic-capture-report?task_id=${taskId}`,
      method: 'get',
    })
  },
  postEditReport(id: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/add-statistic-capture-report`,
      method: 'post',
      data: data,
    })
  },
  postBulkUploadStaticsReports(pId: any, sId: any, data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${pId}/statistics-capture/upload-bulk-data?schedule_id=${sId}`,
      method: 'post',
      data: data,
    })
  },
  getDownloadStatisticReports(id: any, sId: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/statistics-capture/download-template?schedule_id=${sId}`,
      method: 'get',
      responseType: 'blob',
    })
  },
}

export default api
